import { HostedGamesService } from '@hosted-games/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ReassignGameByTokenPathParams } from '@core-http';

export class ReassingGameCommandHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);

  reassign(gameId: string, token: string): Observable<void> {
    const pathParams: ReassignGameByTokenPathParams = { hostedGameId: gameId, reassignToken: token };

    return this.hostedGamesService.reassignGame(pathParams);
  }
}
